var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 151 151",
    style: {
      enableBackground: "new 0 0 151 151"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 50.599,
    cy: 55.785,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 50.599,
    cy: 55.785,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BC7D64"
    },
    d: "M51.024,63.516 c-4.778-6.302-7.577-15.105-6.697-23.374c-3.326,3.344-5.536,9.164-5.536,15.801c0,10.378,5.39,18.791,12.039,18.791 c3.1,0,5.916-1.846,8.051-4.852C55.887,68.501,53.213,66.4,51.024,63.516z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 69.353,
    cy: 55.785,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 69.353,
    cy: 55.785,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BC7D64"
    },
    d: "M69.779,63.516 C65,57.214,62.202,48.41,63.082,40.142c-3.327,3.344-5.536,9.164-5.536,15.801c0,10.378,5.388,18.791,12.037,18.791 c3.1,0,5.918-1.846,8.052-4.852C74.642,68.501,71.967,66.4,69.779,63.516z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 88.108,
    cy: 55.785,
    rx: 12.038,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 88.108,
    cy: 55.785,
    rx: 12.038,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BC7D64"
    },
    d: "M88.534,63.516 c-4.78-6.302-7.576-15.105-6.697-23.374C78.51,43.486,76.3,49.306,76.3,55.943c0,10.378,5.39,18.791,12.037,18.791 c3.102,0,5.919-1.846,8.054-4.852C93.397,68.501,90.723,66.4,88.534,63.516z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 106.863,
    cy: 55.785,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 106.863,
    cy: 55.785,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BC7D64"
    },
    d: "M107.288,63.516 c-4.778-6.302-7.577-15.105-6.696-23.374c-3.328,3.344-5.536,9.164-5.536,15.801c0,10.378,5.388,18.791,12.036,18.791 c3.101,0,5.918-1.846,8.053-4.852C112.15,68.501,109.476,66.4,107.288,63.516z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 41.222,
    cy: 69.526,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FCB89D"
    },
    cx: 41.222,
    cy: 69.526,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    d: "M41.647,77.256c-4.778-6.302-7.577-15.105-6.697-23.374 c-3.328,3.343-5.536,9.164-5.536,15.801c0,10.378,5.389,18.791,12.037,18.791c3.1,0,5.917-1.846,8.052-4.853 C46.51,82.241,43.835,80.14,41.647,77.256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 61.019,
    cy: 69.526,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FCB89D"
    },
    cx: 61.019,
    cy: 69.526,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    d: "M61.444,77.256c-4.779-6.302-7.577-15.105-6.697-23.374 c-3.327,3.343-5.536,9.164-5.536,15.801c0,10.378,5.389,18.791,12.036,18.791c3.101,0,5.918-1.846,8.053-4.853 C66.308,82.241,63.633,80.14,61.444,77.256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 80.814,
    cy: 69.526,
    rx: 12.038,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FCB89D"
    },
    cx: 80.814,
    cy: 69.526,
    rx: 12.038,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    d: "M81.24,77.256c-4.778-6.302-7.577-15.105-6.697-23.374 c-3.326,3.343-5.537,9.164-5.537,15.801c0,10.378,5.391,18.791,12.038,18.791c3.101,0,5.918-1.846,8.053-4.853 C86.102,82.241,83.428,80.14,81.24,77.256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 100.611,
    cy: 69.526,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FCB89D"
    },
    cx: 100.611,
    cy: 69.526,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    d: "M101.037,77.256c-4.779-6.302-7.577-15.105-6.696-23.374 c-3.328,3.343-5.537,9.164-5.537,15.801c0,10.378,5.388,18.791,12.037,18.791c3.101,0,5.917-1.846,8.053-4.853 C105.9,82.241,103.225,80.14,101.037,77.256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    cx: 116.24,
    cy: 69.526,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FCB89D"
    },
    cx: 116.24,
    cy: 69.526,
    rx: 12.037,
    ry: 18.791
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FBA685"
    },
    d: "M116.666,77.256c-4.78-6.302-7.577-15.105-6.697-23.374 c-3.327,3.343-5.536,9.164-5.536,15.801c0,10.378,5.388,18.791,12.036,18.791c3.102,0,5.919-1.846,8.053-4.853 C121.528,82.241,118.853,80.14,116.666,77.256z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDA5B"
    },
    d: "M19.482,76.222c0.498-33.876,25.627-61.174,56.571-61.174 c30.945,0,56.074,27.298,56.572,61.174h10.034c-0.499-39.967-30.119-72.202-66.606-72.202S9.948,36.255,9.448,76.222H19.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFDA5B"
    },
    d: "M10.414,89.429v12.894c0,24.663,18.193,44.656,40.635,44.656 h50.012c22.442,0,40.636-19.993,40.636-44.656V89.429H10.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BFA444"
    },
    d: "M151,80.613c0,4.947-3.807,9.238-8.308,9.238H8.957 C4.456,89.851,0,85.56,0,80.613v-0.405c0-4.947,4.456-9.357,8.957-9.357h133.735c4.501,0,8.308,4.41,8.308,9.357V80.613z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M19.493,71.251c0,0,23.807,33.896,32.269,33.011 c8.461-0.885,15.042-7.085,24.309-7.085c8.466,0,26.863,7.102,41.368,1.328c7.824-3.114,15.715-27.254,15.715-27.254 S19.859,62.372,19.493,71.251z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6b1d851ffe2c3e07702b0f931ed9a34a.svg";
export { ForwardRef as ReactComponent };